exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-dc49ef06] {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.svg-external-icon[data-v-dc49ef06] {\n  background-color: currentColor;\n  -webkit-mask-size: cover!important;\n          mask-size: cover!important;\n  display: inline-block;\n}\n", ""]);

// exports
